import { render, staticRenderFns } from "./ChannelConfigurationFields.vue?vue&type=template&id=457fb0ad&scoped=true"
import script from "./ChannelConfigurationFields.vue?vue&type=script&lang=js"
export * from "./ChannelConfigurationFields.vue?vue&type=script&lang=js"
import style0 from "./ChannelConfigurationFields.vue?vue&type=style&index=0&id=457fb0ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457fb0ad",
  null
  
)

export default component.exports